import { render, staticRenderFns } from "./couponPropertyUserDetailList.vue?vue&type=template&id=577bc04b&scoped=true"
import script from "./couponPropertyUserDetailList.vue?vue&type=script&lang=js"
export * from "./couponPropertyUserDetailList.vue?vue&type=script&lang=js"
import style0 from "./couponPropertyUserDetailList.vue?vue&type=style&index=0&id=577bc04b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577bc04b",
  null
  
)

export default component.exports